<template>
  <section>
      <multiselect
          v-model="countryVal"
          :options="countriesPromptList"
          :multiple="multiple"
          :close-on-select="!multiple"
          :show-labels="false"
          :clear-on-select="false"
          :searchable="true"
          @close="closeSelect"
          @select="selectAction"
          @input="onChange"
          @search-change="searchChange"
          @open="open"
          size="sm"
      ></multiselect>
    <b-overlay :show="showOverlay > 0" class="overlay" rounded="sm"></b-overlay>
  </section>
</template>

<script>
    import Multiselect from 'vue-multiselect'

    export default {
      name: "countriesSelect",
      props: {
        initCountries: Array,
        countryChange: Function,
        multiple: Boolean
      },
      components: {
        Multiselect
      },
      data() {
        return {
          countriesPromptList: [],
          countriesFullList: [],
          sendTimer: null,
          countrySearch: '',
          numberPromptItem: 10,
          isOpen: false,
          showOverlay: 0,
          countryVal: [],
        }
      },
      methods: {
        open: function () {
          this.isOpen = true
        },
        onChange: function () {
          if (!this.isOpen) {
            this.returnValue()
          }
        },
        closeSelect: function () {
          this.isOpen = false
          this.returnValue()
        },
        returnValue: function () {
          this.countryChange(this.getFullValue(this.countryVal))
        },
        selectAction: function (name) {
          this.countrySearch = name
        },
        searchChange: function (searchQuery) {
          if (searchQuery.length < 2) {
            return
          }
          if (this.sendTimer != null) {
            clearTimeout(this.sendTimer);
          }
          this.sendTimer = setTimeout(() => {this.sendRequest(searchQuery)}, 1000);
        },
        sendRequest: function (searchQuery) {
          this.showOverlay ++
          this.$store.dispatch('SEND_GET', {
            url: '/client-country?sort=name&sortDir=asc&name='+ searchQuery +'&limit='+
                this.numberPromptItem,
            th: this,
            getSuccessResponse: (data) => {
              this.countriesFullList = data.data
              this.countriesPromptList = this.getOnlyNames(data.data)
            },
            getResponse: () => {
              this.showOverlay --;
            },
            showSuccessMessage: false
          })
        },
        getFullValue: function (countryName) {
          if (Array.isArray(countryName)) {
            let dataList = []
            for (let key in countryName) {
              dataList.push(this.getFullValue(countryName[key]))
            }

            return dataList
          } else {
            for (let key in this.countriesFullList) {
              let val = this.countriesFullList[key]
              if (countryName == val.name) {
                return val
              }
            }
          }

          return countryName
        }
      },
      computed: {
      },
      mounted() {
      },
      created() {
        this.countryVal = this.initCountries
      },
    }
</script>

<style scoped>
  .overlay {
    z-index: 51;
  }
</style>